import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { ETooltipPlacement, TTooltipTheme, TTooltipTrigger } from '../components/tooltip/tooltip.types';
import { TooltipService } from '../services/tooltip.service';

@Directive({
    selector: '[fkTooltip]',
})
export class TooltipDirective implements OnDestroy {
  @Input()
  public fkTooltip: string = '';

  @Input()
  public fkTooltipTheme: TTooltipTheme = 'dark';

  @Input()
  public fkTooltipPlacement: ETooltipPlacement = ETooltipPlacement.AUTO;

  @Input()
  // Implemented only hover.
  // TODO: Imlement triggers: click, focus, hint
  public fkTooltipTrigger: TTooltipTrigger = 'hover';

  @Input()
  public fkTooltipDelay: number = 500;

  @Input()
  public fkTooltipWidth: string = 'auto';

  private _timeout: any;

  constructor(
    private readonly _elemRef: ElementRef,
    private readonly _tooltipService: TooltipService,
  ){

  }

  ngOnDestroy(): void {
    this.onLeave();
  }

  @HostListener('mouseenter', ['$event'])
  public onEnter() {
    if (this.fkTooltipTrigger !== 'hover') {
      return;
    }

    if (!this.fkTooltip) {
      return;
    }

    this._timeout = setTimeout(()=>{
      this._initTooltip();
    }, this.fkTooltipDelay);
  }

  @HostListener('mouseleave', ['$event'])
  public onLeave() {
    if (this._timeout) {
      clearTimeout(this._timeout);
    }

    this._tooltipService.hide()
  }

  private _initTooltip(){
    this._tooltipService.show({
      content: this.fkTooltip,
      theme: this.fkTooltipTheme,
      placement: this.fkTooltipPlacement,
      width: this.fkTooltipWidth,
    }, this._elemRef);
  }
}
